import React from 'react';
import { ConferencingHeader } from './ConferencingHeader';

export const Header = ({ logoUrl = null, showLogo }) => {
    return <ConferencingHeader logoUrl={logoUrl || null} showLogo={showLogo} />;
};
